import React from 'react';
import { motion } from 'framer-motion';
import { useGentleMotion as useReducedMotion } from '../hooks/useGentleMotion';
import { Reveal } from './Reveal';
import { Doodles, DoodleSpec } from './Doodles';
const doodles: DoodleSpec[] = [{
  kind: 'star',
  top: '14%',
  left: '8%',
  size: 24,
  color: '#F6C453',
  rotate: -12
}, {
  kind: 'sparkle',
  top: '26%',
  left: '88%',
  size: 22,
  color: '#6CBBD5'
}, {
  kind: 'confetti',
  top: '72%',
  left: '12%',
  size: 14,
  color: '#F27C70',
  rotate: 18
}, {
  kind: 'star',
  top: '80%',
  left: '86%',
  size: 18,
  color: '#F3A340',
  rotate: 10
}, {
  kind: 'dot',
  top: '46%',
  left: '4%',
  size: 10,
  color: '#EAF7EF'
}];
export function TransitionBanner() {
  const reduce = useReducedMotion();
  return <section className="relative w-full overflow-hidden bg-navy py-16 sm:py-24" aria-label="El verdadero valor del producto" data-id="element-344" data-mp="2o7b0ch1v0jy5">
      <Doodles specs={doodles} data-id="element-345" data-mp="tul43so0qynl" />

      <Reveal className="relative mx-auto max-w-3xl px-5 text-center sm:px-8" data-id="element-346" data-mp="ttt9ak28x4yd">
        <p className="font-display text-base font-bold uppercase tracking-[0.12em] text-white/70 sm:text-lg" data-id="element-347" data-mp="2uww5l2ddfn14">
          No estás comprando solamente 365 actividades.
        </p>
        <p className="mt-6 font-display text-[1.9rem] font-extrabold uppercase leading-[1.08] text-white sm:text-5xl" data-id="element-348" data-mp="2q4mfnmc9amyu">
          Estás comprando
          <br data-id="element-349" data-mp="2h6skwfu541ds" />
          <motion.span className="inline-block text-sun" animate={reduce ? undefined : {
          scale: [1, 1.05, 1]
        }} transition={{
          duration: 3.2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-350" data-mp="2h7c5y5f375w1">
            365 veces menos
          </motion.span>{' '}
          preguntándote:
          <br data-id="element-351" data-mp="34timxh6hnvye" />
          <span className="text-white/90" data-id="element-352" data-mp="34xg5a0l8sjh8">“¿Qué hacemos hoy?”</span>
        </p>
        <motion.p className="mt-8 font-display text-sm font-extrabold uppercase tracking-[0.3em] text-coral sm:text-base" animate={reduce ? undefined : {
        opacity: [0.7, 1, 0.7]
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-353" data-mp="2zvqywy8ystzh">
          Abre. Elige. Crea.
        </motion.p>
      </Reveal>
    </section>;
}